import { Text, TextInput, StyleSheet, View } from "react-native";
import { colors } from "../constants/colors";

export const BaseInput = (props) => {
  return (
    <View
      style={[
        {
          borderRadius: 10,
          backgroundColor: colors.lightBlue,
          marginBottom: 20,
          paddingHorizontal: 20,
        },
        styles.container,
        props.containerStyle,
      ]}
    >
      {props.label && (
        <Text style={[styles.labelStyle, props.labelStyle]}>{props.label}</Text>
      )}
      <TextInput
        placeholder="test"
        placeholderTextColor={colors.grey}
        style={[styles.textInput, props.style]}
        {...props}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  labelStyle: {
    marginBottom: 4,
    color: colors.darkPurple,
    position: "absolute",
    top: 10,
    left: 20,
  },
  container: {
    height: 60,
    justifyContent: "flex-end",

    shadowColor: colors.darkPurple,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4.65,

    elevation: 8,
  },
  textInput: {
    color: colors.darkGrey,
    fontSize: 16,
    paddingBottom: 10,
  },
});
